import cn from "classnames";
import React, { Component } from "react";
import { Waypoint } from "react-waypoint";

// specific realization with visibility effect, not use in another places
const isHidden = function (ele, container) {
    const { bottom, top } = ele.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();
    return top <= containerRect.top ? containerRect.top - top <= 0 : bottom - containerRect.bottom <= 0;
};

export default class DateMessage extends Component {
    state = { show: false };

    componentDidMount() {
        if (isHidden(this.dateRef, this.props.chatBodyRef)) {
            this.props.changeDate(this.props.text);
        }
    }

    handleDateEnter = ({ currentPosition, previousPosition }, { prev }) => {
        this.setState({ show: true });
        const { changeDate } = this.props;
        if (currentPosition === "inside" && previousPosition === "above") {
            if (prev) {
                return changeDate(prev.text);
            }
        }
    };

    handleDateLeave = ({ currentPosition, previousPosition }, { text }) => {
        this.setState({ show: false });
        const { changeDate } = this.props;
        if (currentPosition === "above" && previousPosition === "inside") {
            return changeDate(text);
        }
    };

    render() {
        const { dates, text } = this.props;
        const current = dates.find((date) => date.text === text);
        const cname = cn({
            "chat__body-item chat-msg chat-msg--center": true,
            "chat-msg--hidden": (dates[0] && dates[0].text === text) || !this.state.show,
        });
        return (
            <Waypoint
                topOffset="75px"
                bottomOffset="-75px"
                onEnter={(data) => this.handleDateEnter(data, current)}
                onLeave={(data) => this.handleDateLeave(data, current)}
            >
                <div className={cname} ref={(el) => (this.dateRef = el)}>
                    {current.text}
                </div>
            </Waypoint>
        );
    }
}
